module.exports = __webpack_public_path__ + "static/media/BGP-CHLSeries.a1384361.pdf";